import { isEitherNone } from "iotera-base/object";

export function getToken() {

    const id = localStorage.getItem('iotera-tenant-id');
    const token = localStorage.getItem('iotera-tenant-token');

    if (isEitherNone(id, token)) {
        removeToken();
        return null;
    }

    return { id, token }
}

export function setToken(id, token) {
    localStorage.setItem('iotera-tenant-id', id);
    localStorage.setItem('iotera-tenant-token', token);
}

export function removeToken() {
    localStorage.removeItem('iotera-tenant-id');
    localStorage.removeItem('iotera-tenant-token');
}
